import LegalPage from "@/pages/legal/LegalPage";

export default function Privacy() {
  return (
    <LegalPage title="Privacy Policy" testId="page-privacy">
      <p>
        This Privacy Policy explains what information LeadGen collects, how we use it, and the choices you have.
        We keep this short and in plain English because we want you to actually read it.
      </p>

      <h2>1. What we collect</h2>
      <ul>
        <li>
          <strong>Business inputs</strong> you submit — website URL, business name, type, location, product/service,
          target customer, budget, goal, competitors, USP, brand tone, and optional contact email.
        </li>
        <li>
          <strong>Scraped website content</strong> from the public URL you paste — titles, headings, meta
          descriptions, visible paragraphs and CTA text. We never log in to or scrape private areas of your site.
        </li>
        <li>
          <strong>Generated plan data</strong> — the plan produced by the AI, the model used, the Growth Score, and
          your action-completion state.
        </li>
        <li>
          <strong>Ship-proof uploads</strong> — screenshots you choose to upload as proof-of-completion for your
          actions. Stored in Emergent Object Storage.
        </li>
        <li>
          <strong>Session identifier</strong> — a random UUID stored in your browser&apos;s localStorage so you can
          return to your plans. We do not use third-party advertising cookies.
        </li>
        <li>
          <strong>Payment metadata</strong> — if you buy a paid tier, Razorpay collects your billing details on
          their checkout. We store only the order ID, payment ID, tier purchased and whether the plan is paid.
        </li>
      </ul>

      <h2>2. What we do with it</h2>
      <ul>
        <li>Generate your marketing plan and let you return to it later.</li>
        <li>Debug and improve the Service.</li>
        <li>Process payments through Razorpay (if you upgrade).</li>
        <li>Respond to support requests when you email us.</li>
      </ul>
      <p>We do not sell your data. We do not share your inputs or your generated plans with other users.</p>

      <h2>3. Who we share with</h2>
      <ul>
        <li>
          <strong>AI providers</strong> — Anthropic (Claude) and OpenAI (ChatGPT) receive your business inputs
          and scraped website content so they can generate the plan. They do not use this content to train their
          models when we access them via the Emergent LLM gateway.
        </li>
        <li>
          <strong>Razorpay</strong> — processes any payments you make. Razorpay&apos;s own privacy policy applies
          to the billing data you give them.
        </li>
        <li>
          <strong>Emergent</strong> — our hosting and object-storage provider stores the generated plans and your
          ship-proof uploads.
        </li>
      </ul>

      <h2>4. How long we keep it</h2>
      <p>
        Plans and inputs are kept for as long as your session identifier exists in our database. You can request
        deletion of your plans and uploads at any time by emailing{" "}
        <a href="mailto:support@madwithppc.com">support@madwithppc.com</a>.
      </p>

      <h2>5. Your rights</h2>
      <p>
        Depending on where you live, you may have the right to access, correct, export or delete the personal
        information we hold about you. Email us from the address you used in LeadGen and we&apos;ll action your
        request within a reasonable time.
      </p>

      <h2>6. Children</h2>
      <p>LeadGen is not directed at children under 16 and we do not knowingly collect their data.</p>

      <h2>7. Security</h2>
      <p>
        We use TLS for data in transit and standard access controls on our storage. No system is perfectly secure,
        so we encourage you not to upload sensitive personal information in your ship-proof screenshots.
      </p>

      <h2>8. Changes</h2>
      <p>
        We may update this policy. Material changes will be reflected on this page with a new &quot;Last
        updated&quot; date.
      </p>

      <h2>9. Contact</h2>
      <p>
        Privacy questions? Email <a href="mailto:madwithppc@gmail.com">madwithppc@gmail.com</a>.
      </p>
    </LegalPage>
  );
}
